// extracted by mini-css-extract-plugin
module.exports = {"onboarding-profile-content-wrapper":"Onboarding_onboarding-profile-content-wrapper__Ik6ST"};